<template>
    <section class="padding-vertical-content mb-3 mb-lg-4" id="paso-4">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="white-content mb-2">
                        <b-card-text v-if="!esRenovacion || manager.documentacion_obligatoria_bases">
                            <p style="font-size: 19px;">{{ $t('bases.adjuntar_foto_perfil') }}</p>
                            <ul>
                                <li style="font-size: 19px;"><b>{{ $t('bases.foto_perfil') }}</b></li>
                            </ul>
                            <p style="font-size: 19px;">{{ $t('bases.peso_imagenes', {peso: dropzoneOptions.maxFilesize}) }}</p>
                        </b-card-text>
                        <b-card-text v-else>
                            <h4>{{ $t('bases.imagenes_renovacion', {imagen: 'foto de perfil' }) }}</h4>
                        </b-card-text>
                        <vue-dropzone
                            ref="myVueDropzone" 
                            id="dropzone"
                            v-on:vdropzone-success="vdropzone_success_handler"
                            :options="dropzoneOptions"
                        >
                        </vue-dropzone>
                        <h4 style="font-size: 24px;" v-if="esRenovacion || !manager.documentacion_obligatoria_bases" class="mt-2 text-uppercase">{{ $t('bases.fotos_opcionales', {foto: 'foto de perfil'}) }}</h4>
                        <div class="mt-3">
                            <button @click="terminar" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-4" :disabled="desactivar">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                            <button @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button ml-2' : 'button effect-button ml-2'" id="volver-paso-3" :disabled="!paso_activo" >
                                <span>{{ $t('formularios.atras') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
    props: ["base", "paso_activo", "esMovil"],
    created() {
        this.dropzoneOptions["url"] = this.config.API_BASE + "/f/guardar-foto-deportista";
    },
    data() {
        return {
            formulario: null,
            dropzoneOptions: {
                url: null,
                thumbnailWidth: 150,
                maxFilesize: 10,
                maxFiles: 1,
                uploadMultiple: false,
                dictDefaultMessage: "Arrastra aquí tu foto de perfil",
            },
            foto_url: '',
            esRenovacion: window.location.href.indexOf("renovar") > -1
        };
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        desactivar() {
            if (!this.esRenovacion && this.manager.documentacion_obligatoria_bases) {
                if (!this.paso_activo || this.foto_url == '') {
                    return true;
                } else {
                    return false
                }
            } else {
                return false;
            }
        }
    },
    methods: {
        vdropzone_success_handler(file, response) {
            this.foto_url = response.url;
        },
        terminar() {
            this.base.foto_url = this.foto_url;
            this.base.teatro_id = this.teatro.id;
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro,
                }
            }
            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {
                this.base.categoria_base.session_id = res.data.session_id;
            });
            this.$emit("terminado");
        },
        volver() {
            this.$emit('volver');
        },
    },
    components: {
        vueDropzone: vue2Dropzone
    },
};
</script>